<template>
  <div>
    <h3 class="font-medium text-m1">Education</h3>
    <p v-if="educationNameText" class="text-body mt-8">{{ educationNameText }}</p>
    <p v-if="educationSubText" class="text-grey-body flex text-small items-center mt-8">{{ educationSubText }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Education',
  props: {
    selectedSitter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    educationNameText() {
      const { schoolName, yearGraduated } = this.selectedSitter.education;
      if (schoolName) {
        return yearGraduated !== 'Select' && yearGraduated !== null ? `${schoolName} (${yearGraduated})` : schoolName;
      }
      return null;
    },

    educationSubText() {
      const { schoolName, levelOfEducation, yearGraduated, major, currentlyAttending } = this.selectedSitter.education;

      if (!schoolName) {
        return null;
      }

      if (levelOfEducation === 'graduate_degree') {
        if (yearGraduated) {
          return major !== '' ? `Graduate degree in ${major}` : 'Graduate degree';
        }
        return `Graduate Program, ${major}`;
      }

      if (yearGraduated) {
        return major !== '' ? `Degree in ${major}` : 'Degree received';
      }

      if (currentlyAttending && major !== '') {
        return `Majoring in ${major}`;
      }

      return null;
    },
  },
};
</script>
